import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.39 3.61a2 2 0 0 0-.798-.49Q19.23 3 18.816 3c-.414 0-.859.093-1.284.269a3.3 3.3 0 0 0-1.068.692l-2.279 2.278-7.39-2.12a1.75 1.75 0 0 0-1.722.446L3.887 5.75a1.76 1.76 0 0 0-.497 1.48 1.76 1.76 0 0 0 .88 1.29l4.896 2.737-1.412 1.412-2.337-.446a1.75 1.75 0 0 0-1.568.482l-.336.336a1.76 1.76 0 0 0-.497 1.48 1.76 1.76 0 0 0 .88 1.29L6.65 17.35l1.54 2.752a1.755 1.755 0 0 0 2.77.384l.335-.336c.41-.41.59-.997.482-1.568l-.446-2.337 1.412-1.411 2.738 4.894a1.755 1.755 0 0 0 2.769.384l1.186-1.186c.45-.45.621-1.11.446-1.723l-2.12-7.39 2.278-2.278c.417-.416.749-1.049.888-1.692a2.9 2.9 0 0 0 .044-1.053 2.1 2.1 0 0 0-.58-1.182"
    }, null, -1)
  ])))
}
export default { render: render }